module.exports = __webpack_public_path__ + "assets/media/1.8acacabc.wav";